module.exports = __webpack_public_path__ + "static/media/storeDetaillBg.7b205d56.png";